import restCrudReducer from '../../../np-crud/store/restCrudReducer';

const [crudInitialState, crudReducer] = restCrudReducer({
    pluginName: 'STATISTIC',
    entityName: 'Report',
});

const initialState = {
    ...crudInitialState,
    customers: [],
    orders: [],
    transportCollies: [],
    collies: [],
    users: [],
    columns: [{
        title: 'User name',
        field: 'UserName',
        emptyValue: ' 0',

    },
    {
        title: 'Total',
        field: 'Total',
        emptyValue: 0,
        hiden: false
    }]


};
const reducer = (state = initialState, action) => {
    // Handle CRUD actions
    const newState = crudReducer(state, action);
    // If CRUD reducer handled the action
    if (newState !== null) {
        return newState;
    }

    // Handle other actions
    switch (action.type) {
        case 'STATISTIC|STATISTIC_REPORT_SUCCESS':
            return { ...state, loaded: action.data };
        case 'REPORT|REPORT_COLUMNS_SUCCESS':
            return { ...state, columns: [...action.column] };
        case 'STATISTIC|REPORT_LOAD_CUSTOMERS_SUCCESS':
            return { ...state, customers: action.data };
        case 'STATISTIC|ORDER_LOAD_CUSTOMERS_SUCCESS':
            return { ...state, orders: action.data };
        case 'STATISTIC|TRANSPORT_COLLIES_LOAD_CUSTOMERS_SUCCESS':
            return { ...state, transportCollies: action.data };
        case 'STATISTIC|COLLIS_LOAD_CUSTOMERS_SUCCESS':
            return { ...state, collies: action.data };
        case 'STATISTIC|USERS_LOAD_CUSTOMERS_SUCCESS':
            return { ...state, users: action.data };
        case 'CORE|LOGOUT_SUCCESS':
        case 'CORE|CORE_SET_ACTIVE_CUSTOMER_SUCCESS':
            return initialState;
        default:
            return state;
    }
};

export default reducer;
